import {
  DataSourceType,
  GetClientFlags200Response,
  SubscriptionDetails,
  UserRoleType,
  UserSubscriptionInfo,
} from "@coeff/api";
import { DataSourceTypeDisplayNames } from "@coeff/utils";

export const isPlanManager = (
  user: UserSubscriptionInfo,
  subscriptionDetails?: SubscriptionDetails
) => user?.is_plan_manager || user.user.email === subscriptionDetails?.subscription_owner_email;

export const isPlanMember = (
  user: UserSubscriptionInfo,
  subscriptionDetails?: SubscriptionDetails
) => user.managed_by_user?.email === subscriptionDetails?.subscription_owner_email;

export const isFreeUser = (user: UserSubscriptionInfo, loggedInUserEmail: string) =>
  !user.managed_by_user && user.user.email === loggedInUserEmail;

export const sortUsers = (a: UserSubscriptionInfo, b: UserSubscriptionInfo) => {
  const bName = `${b.user.first_name} ${b.user.last_name}`;
  const aName = `${a.user.first_name} ${a.user.last_name}`;

  if (aName < bName) {
    return -1;
  }
  if (aName > bName) {
    return 1;
  }
  return 0;
};

export const dataSourceTypeToCommaSeparatedString = (
  dataSourceTypes: DataSourceType[],
  limit?: number
): string => {
  const items = dataSourceTypes
    .slice(0, limit)
    .map(dataSourceType => DataSourceTypeDisplayNames[dataSourceType]);

  if (items.length === 0) {
    return "";
  }
  if (items.length === 1) {
    return items[0];
  }
  if (items.length === 2) {
    return `${items[0]} and ${items[1]}`;
  }

  return `${items.slice(0, -1).join(", ")}, and ${items[items.length - 1]}`;
};

const submitHubSpotForm = async (
  formId: string,
  fields: { name: string; value: string | undefined }[]
): Promise<boolean> => {
  try {
    const response = await fetch(
      `https://api.hsforms.com/submissions/v3/integration/submit/7039851/${formId}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fields }),
      }
    );
    if (!response.ok) {
      console.error("Error submitting HubSpot form:", response.statusText);
      return false;
    }
    return true;
  } catch (error) {
    console.error("Error submitting HubSpot form:", error);
    return false;
  }
};

export const submitContactSalesForm = (
  comments: string,
  clientFlags?: GetClientFlags200Response
): Promise<boolean> => {
  if (!clientFlags) {
    return Promise.resolve(false);
  }
  const { email, first_name, last_name } = clientFlags;
  return submitHubSpotForm("e6595757-759d-4064-bdf7-625e42d899ed", [
    { name: "firstname", value: first_name },
    { name: "lastname", value: last_name },
    { name: "email", value: email },
    { name: "how_can_we_help_", value: comments },
  ]);
};

export const submitWebDashboardExpiredSalesForm = (
  comments: string,
  clientFlags?: GetClientFlags200Response
): Promise<boolean> => {
  if (!clientFlags) {
    return Promise.resolve(false);
  }
  const { email, first_name, last_name } = clientFlags;
  return submitHubSpotForm("253b6811-8b20-41df-96c1-375f2027e352", [
    { name: "firstname", value: first_name },
    { name: "lastname", value: last_name },
    { name: "email", value: email },
    { name: "how_can_we_help_", value: comments },
  ]);
};

export const submitWebDashboardProactiveSalesForm = (
  comments: string,
  clientFlags?: GetClientFlags200Response
): Promise<boolean> => {
  if (!clientFlags) {
    return Promise.resolve(false);
  }
  const { email, first_name, last_name } = clientFlags;
  return submitHubSpotForm("906be710-895e-4f88-8ef7-7ee247534492", [
    { name: "firstname", value: first_name },
    { name: "lastname", value: last_name },
    { name: "email", value: email },
    { name: "how_can_we_help_", value: comments },
  ]);
};
